import React from 'react';
import {FieldValues, Path, UseFormSetFocus} from 'react-hook-form';

export const useFocusFieldOnEnter = <T extends FieldValues>(
  setFocus: UseFormSetFocus<T>,
  name: Path<T>,
) =>
  React.useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key !== 'Enter' || event.nativeEvent.isComposing) {
        return;
      }

      const input = event.currentTarget;

      setFocus(name);

      if (document.activeElement !== input) {
        event.preventDefault();
      }
    },
    [setFocus, name],
  );
